import { createSelector } from 'reselect';

import { selectCabinType } from '@/ducks/filters/selectors';

import { isLockItInFlowCabin } from './isLockItCabin';

export const selectIsLockItInFlowCabin = createSelector(selectCabinType, (cabinType) => isLockItInFlowCabin(cabinType));
